import mapboxgl from 'mapbox-gl';

export class Map {

    constructor ( target = '.js-map', key = '', options = {} ) {
        this.target = target;
        this.key = key;

        this.options = {
            ...options
        }
    }

    init () {
        mapboxgl.accessToken = 'pk.eyJ1Ijoicm9vdHN0dWRpbyIsImEiOiJja3BtamJnYnQwNmVsMnZud2I2c2ZnamN2In0.E-sYlhDihHGBlHvwjXhmVQ'

        this.$container = document.querySelector( this.target );

        if ( !this.$container ) {
            return false;
        }

        if ( this.$container.dataset.lng && this.$container.dataset.lat ) {
            this.createSingleMarker();

            this.map.scrollZoom.disable();
            const nav = new mapboxgl.NavigationControl();
            this.map.addControl( nav, 'top-left' );
        }

        if ( this.$container.dataset.markers ) {
            this.createMarkers();
        }

    }

    async createMarkers () {

        this.lats = [];
        this.lngs = [];

        this.fetchMarkers().then( response => {
            this.fetchCategories().then( catResponse => {

                this.map = new mapboxgl.Map( {
                    container: this.$container,
                    style: 'mapbox://styles/mapbox/streets-v11',
                    zoom: 15,
                    attributionControl: false
                } );

                response.data.forEach( item => {
                    const category = catResponse.data.find( cat => {
                        return cat.slug === item.shop_category.slug
                    } )
                    const el = document.createElement( 'div' );
                    el.className = 'marker';
                    el.style.backgroundImage =
                        `url("${category.icon.url}")`;
                    el.style.width = '29px';
                    el.style.height = '33px';
                    el.style.backgroundSize = '100%';

                    const marker = new mapboxgl.Marker( el )
                    .setLngLat( item.map.center )
                    .setPopup(
                        new mapboxgl.Popup( {
                            offset: 25,
                            maxWidth: '360px',
                            focusAfterOpen: false,
                        } )
                        .setHTML( this.getPopUpHTML( item ) )
                    )
                    .addTo( this.map );

                    this.lats.push( item.map.center[ 0 ] )
                    this.lngs.push( item.map.center[ 1 ] )
                } )

                const nav = new mapboxgl.NavigationControl();
                this.map.addControl( nav, 'top-left' );
                const minlat = Math.min.apply( null, this.lats ),
                    maxlat = Math.max.apply( null, this.lats ),
                    minlng = Math.min.apply( null, this.lngs ),
                    maxlng = Math.max.apply( null, this.lngs );

                console.log( [
                    [minlat, minlng],
                    [maxlat, maxlng]
                ] );

                this.map.fitBounds( [
                    [minlat, minlng],
                    [maxlat, maxlng],
                ], {
                    padding: 50,
                    duration: 1000
                } );

                this.map.scrollZoom.disable();
                console.log(this.map.tap)
                if (this.map.tap) this.map.tap.disable();
            } )
        } )

    }


    async fetchMarkers () {
        const response = await fetch( this.$container.dataset.markers );
        return await response.json();
    }

    async fetchCategories () {
        const response = await fetch( `/api/taxonomies/shop_category/terms/` );
        return await response.json();
    }

    getPopUpHTML ( item ) {
        return `
        <div class="c-card u-br-size-xxs u-br-shaped-rounded">
            <div class="c-card__content">
                <h4 class="c-card__title">
                    ${item.title}
                </h4>
                <div class="c-card__copy is-quarantine">
                    <p>
                        ${item.street_address}<br/>
                        ${item.city_town}<br/>
                        ${item.postcode}<br/>
                    </p>
                </div>
                <div class="c-card__actions">
                    <a href="${item.url}" class="c-button">
                        More info
                    </a>
                </div>
            </div>
        </div>`
    }

    createSingleMarker () {
        const center = [
            this.$container.dataset.lng,
            this.$container.dataset.lat,
        ]

        this.map = new mapboxgl.Map( {
            container: this.$container,
            style: 'mapbox://styles/mapbox/streets-v11',
            center,
            zoom: 15,
            attributionControl: false
        } );

        const el = document.createElement( 'div' );
        el.className = 'marker';
        el.style.backgroundImage =
            'url("/resources/images/map-icon.svg")';
        el.style.width = '29px';
        el.style.height = '33px';
        el.style.backgroundSize = '100%';

        const marker = new mapboxgl.Marker( el )
        .setLngLat( center )
        .addTo( this.map );
    }

}
